import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import CleanImg from "../../../../../../static/images/shop/clean.svg";
import Energy from "../../../../../../static/images/shop/energy.svg";
import Flavor from "../../../../../../static/images/shop/flavor.svg";
import GainfulIcon from "Images/profile/gainful_logo.svg";
import Ingredients from "../../../../../../static/images/shop/ingredients.svg";
import Personalized from "../../../../../../static/images/shop/personalized.svg";
import RD from "../../../../../../static/images/shop/rd.svg";
import caffeine from "./images/caffeine.svg";
import decaf from "./images/decaf.svg";
import sugar from "./images/sugar.svg";
import styles from "./styles.module.scss";
import H2Font from "Root/profile/components/common/H2Font";
import RegFont from "Root/profile/components/common/RegFont";
import Activity from "Images/checkout/activity.svg";
const XMark = (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("line", { x1: "1.20711", y1: "1.29289", x2: "15.2071", y2: "15.2929", stroke: "#333333", strokeWidth: "2" }), _jsx("line", { x1: "0.792893", y1: "15.2929", x2: "14.7929", y2: "1.29289", stroke: "#333333", strokeWidth: "2" })] }));
const CheckMark = (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", children: _jsx("path", { d: "M1 7.89642L5.10526 12.0017L14 1.73853", stroke: "#333333", strokeWidth: "2", strokeLinecap: "round" }) }));
const data = {
    protein: [
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: sugar, alt: "protein", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "Grams of Protein" })] }),
            "19-26g",
            "<19g",
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Ingredients, alt: "protein", height: 30, width: 30 }), " ", _jsxs(RegFont, { className: styles.tableText, children: [" ", "No Artificial Ingredients", " "] })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: CleanImg, alt: "protein", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: " No Fillers" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Personalized, alt: "protein", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: " Personalized" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: RD, alt: "protein", height: 30, width: 30 }), " ", _jsxs(RegFont, { className: styles.tableText, children: [" ", "Free Registered Dietitian access"] })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Energy, alt: "protein", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "Effective Formulas" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Flavor, alt: "protein", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "Choose Your Flavor Daily" })] }),
            CheckMark,
            XMark,
        ],
    ],
    hydration: [
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: sugar, alt: "hydration", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "Grams of Sugar" })] }),
            "<2g",
            "11g++",
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Ingredients, alt: "hydration", height: 30, width: 30 }), " ", _jsxs(RegFont, { className: styles.tableText, children: [" ", "No Artificial Ingredients", " "] })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: CleanImg, alt: "hydration", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: " No Fillers" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Personalized, alt: "hydration", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: " Personalized" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: RD, alt: "hydration", height: 30, width: 30 }), " ", _jsxs(RegFont, { className: styles.tableText, children: [" ", "Free Registered Dietitian access"] })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Energy, alt: "hydration", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "4 Key Electrolytes" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: caffeine, alt: "hydration", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "Caffeinated Options" })] }),
            CheckMark,
            XMark,
        ],
    ],
    preworkout: [
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: decaf, alt: "preworkout", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "Non-caffeinated Options" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Ingredients, alt: "preworkout", height: 30, width: 30 }), " ", _jsxs(RegFont, { className: styles.tableText, children: [" ", "No Artificial Ingredients", " "] })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: CleanImg, alt: "preworkout", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: " No Fillers" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Personalized, alt: "preworkout", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: " Personalized" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: RD, alt: "preworkout", height: 30, width: 30 }), " ", _jsxs(RegFont, { className: styles.tableText, children: [" ", "Free Registered Dietitian access"] })] }),
            CheckMark,
            XMark,
        ],
    ],
    greens: [
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Activity, alt: "hydration", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "3 Targeted Benefits: Focus, Immunity, Gut Health" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Ingredients, alt: "hydration", height: 30, width: 30 }), " ", _jsxs(RegFont, { className: styles.tableText, children: [" ", "No Artificial Ingredients", " "] })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: CleanImg, alt: "hydration", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "Label Transparency - No Proprietary Blends!" })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: RD, alt: "hydration", height: 30, width: 30 }), " ", _jsxs(RegFont, { className: styles.tableText, children: [" ", "Free Registered Dietitian access"] })] }),
            CheckMark,
            XMark,
        ],
        [
            _jsxs(_Fragment, { children: [_jsx("img", { src: Energy, alt: "hydration", height: 30, width: 30 }), " ", _jsx(RegFont, { className: styles.tableText, children: "Delicious Taste" })] }),
            CheckMark,
            XMark,
        ],
    ],
};
const WhyDifferentTable = ({ product }) => {
    return (_jsx("div", { className: styles.wrapper, children: _jsxs("div", { className: styles.content, children: [_jsxs("div", { className: styles.firstSection, children: [_jsx(H2Font, { fontWeight: 400, children: "Why we\u2019re different" }), product === "protein" && (_jsxs("p", { className: styles.text, children: ["When it comes to protein powder, we pride ourselves in offering clean and effective formulas that are ", _jsx("b", { children: "made for you." })] })), product === "hydration" && (_jsx("p", { className: styles.text, children: "Perform at your best with hydration formulas that deliver an effective amount of electrolytes based on your workout frequency, intensity, and sweat levels." })), product === "preworkout" && (_jsx("p", { className: styles.text, children: "Ge the most out of your workout with pre-workout formulas that deliver personalized levels of clinically studied ingredients such as caffeine and creatine." }))] }), _jsx("div", { className: styles.secondSection, children: _jsxs("div", { className: styles.table, children: [_jsxs("div", { className: styles.row, children: [_jsx("div", { className: styles.column_1 }), _jsx("div", { className: styles.column_2, children: _jsx("img", { src: GainfulIcon, alt: "Gainful Icon" }) }), _jsx("div", { className: styles.column_3, children: "Them" })] }), data[product].map((row, rowIndex) => (_jsx("div", { className: styles.row, children: row.map((column, index) => (_jsx("div", { className: styles[`column_${index + 1}`], children: column }, `column-row-${rowIndex}-${index}`))) }, `row-${rowIndex}`)))] }) })] }) }));
};
export default WhyDifferentTable;
